// Configuration
export const SET_CONFIGURATION = 'SET_CONFIGURATION'
export const SET_CONFIGURATION_LAYOUT = 'SET_CONFIGURATION_LAYOUT'
export const SET_CONFIGURATION_DASHBOARD = 'SET_CONFIGURATION_DASHBOARDS'

// Account Dashboard
export const LOAD_DASHBOARD_CONFIGURATION = 'LOAD_DASHBOARD_CONFIGURATION'
export const ADD_WIDGET_TO_ACCOUNT_DASHBOARD = 'ADD_WIDGET_TO_ACCOUNT_DASHBOARD'
export const REMOVE_WIDGET_FROM_ACCOUNT_DASHBOARD = 'REMOVE_WIDGET_FROM_ACCOUNT_DASHBOARD'
export const SWITCH_WORKSPACE_IN_ACCOUNT_DASHBOARD = 'SWITCH_WORKSPACE_IN_ACCOUNT_DASHBOARD'
export const CREATE_WORKSPACE_IN_ACCOUNT_DASHBOARD = 'CREATE_WORKSPACE_IN_ACCOUNT_DASHBOARD'
export const CLEAR_TEMP_AND_COPY_EXISTED_OR_DEFAULT_IN_ACCOUNT_DASHBOARD = 'CLEAR_TEMP_AND_COPY_EXISTED_OR_DEFAULT_IN_ACCOUNT_DASHBOARD'
export const COPY_TEMP_TO_ACCOUNT_DASHBOARD_BY_ID = 'COPY_TEMP_TO_ACCOUNT_DASHBOARD_BY_ID'
export const RESET_WORKSPACE_BEFORE_EDIT_IN_ACCOUNT_DASHBOARD = 'RESET_WORKSPACE_BEFORE_EDIT_IN_ACCOUNT_DASHBOARD'

// Filter
export const SET_FILTERS = 'SET_FILTERS'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'

// Cache
export const SET_CACHE = 'SET_CACHE'
export const CLEAR_CACHE = 'CLEAR_CACHE'
export const CLEAR_PAGE_CACHE = 'CLEAR_PAGE_CACHE'

// Tables
export const SET_CONSIGNMENT_TABLE = 'SET_CONSIGNMENT_TABLE'
